module.exports = __webpack_public_path__ + "09c142902d1e66a31f513f75c0e15c41.png";